<template>
  <div>
    <logo></logo>
    <isuGoogleMap></isuGoogleMap>
    <isuFooter></isuFooter>
    <filters></filters>
    <submit></submit>
    <contact></contact>
  </div>
</template>

<script>
import logo from '@/components/Logo'
import isuGoogleMap from '@/components/Map'
import isuFooter from '@/components/Footer'
import filters from '@/components/Filters'
import submit from '@/components/Submit'
import contact from '@/components/Contact'

export default {
  name: 'home',
  components: {
    logo: logo,
    isuGoogleMap: isuGoogleMap,
    isuFooter: isuFooter,
    filters: filters,
    submit: submit,
    contact: contact
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Home.vue?78a768cc